import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import {
  AdvisorDepotsResponseModel,
  DepotBulkNudgeRequestModel,
  DepotBulkNudgeSendResultModel,
  DepotNudgeClientsPageModel,
  DepotNudgeRequestModel,
  DepotNudgeSendResultModel,
  PocketModel,
  VinsafeEarningsResponseModel,
} from '../../model';

@Injectable({
  providedIn: 'root',
})
export class VinsafeService {
  constructor(private http: HttpClient) {}

  public getClientPockets(clientId: string): Observable<PocketModel[]> {
    const params: HttpParams = new HttpParams().set('client_id', clientId);

    return this.http.get<PocketModel[]>(`${environment.apiEndpoint}/vinsafe/b2b/pockets`, { params });
  }

  public getEarnings(): Observable<VinsafeEarningsResponseModel> {
    return this.http.get<VinsafeEarningsResponseModel>(`${environment.apiEndpoint}/vinsafe/earnings`);
  }

  public getAdvisorDepots(): Observable<AdvisorDepotsResponseModel> {
    return this.http.get<AdvisorDepotsResponseModel>(`${environment.apiEndpoint}/vinsafe/depots`);
  }

  public getClientsWithoutDepot(page: number = 0, pageSize: number = 30): Observable<DepotNudgeClientsPageModel> {
    const params: HttpParams = new HttpParams().set('page', page).set('page_size', pageSize);

    return this.http.get<DepotNudgeClientsPageModel>(
      `${environment.apiEndpoint}/vinsafe/depots/clients-without-depot`,
      { params },
    );
  }

  public sendDepotNudge(clientId: string, body: DepotNudgeRequestModel): Observable<DepotNudgeSendResultModel> {
    return this.http.post<DepotNudgeSendResultModel>(
      `${environment.apiEndpoint}/vinsafe/depots/clients/${clientId}/nudge`,
      body,
    );
  }

  public sendDepotBulkNudge(body: DepotBulkNudgeRequestModel): Observable<DepotBulkNudgeSendResultModel> {
    return this.http.post<DepotBulkNudgeSendResultModel>(`${environment.apiEndpoint}/vinsafe/depots/nudges`, body);
  }
}
